export default __webpack_public_path__ + "static/media/so-funny-kim.f727712c.jpg";